<template>
  <div class="wrapper">
    <main class="flex-shrink-0">
      <nav id="top" class="navbar navbar-expand-lg absolute-top navbar-transparent">
        <div class="container">
          <div class="navbar-translate"><a href="/" rel="tooltip" title="In the Fish" data-placement="bottom"
              class="navbar-brand"><img src="/me/img/icons/itf_logo_128.png" class="logo"></a> <button type="button"
              data-toggle="collapse" data-target="#navigation" aria-controls="navigation-index" aria-expanded="false"
              aria-label="Toggle navigation" class="navbar-toggler navbar-toggler"><span
                class="navbar-toggler-bar bar1"></span> <span class="navbar-toggler-bar bar2"></span> <span
                class="navbar-toggler-bar bar3"></span></button></div>
          <div id="navigation" class="collapse navbar-collapse justify-content-end">
            <ul class="navbar-nav">
              <li class="nav-item"><a href="/home" class="nav-link">Home</a></li>
              <li class="nav-item"><a href="/explore" class="nav-link">Explore Projects</a></li>
              <li class="nav-item"><a href="/about" target="_self" class="nav-link">About</a></li>
              <li class="nav-item"><a href="/contact" target="_self" class="nav-link">Contact</a></li>
              <li class="nav-item"><a href="/me" target="_self" class="nav-link">My Projects</a></li>
            </ul>
          </div>
        </div>
      </nav>
      <div id="content">
        <div class="page-header section-dark" style="background-image: url(&quot;../img/thailand-1.jpg&quot;);">
          <div class="filter"></div>
          <router-view></router-view>
        </div>
      </div>
    </main>
    <footer class="footer mt-auto py-3">
      <div class="container">
        <div class="row justify-content-end">
          <div class="col-lg-6">
            v{{version}} &copy; {{year}} Arketec Limited t/a In the Fish
          </div>
          <div class="col-lg-6 text-lg-right">
            <a class="footer-link pr-2" href="/terms">Terms of Service</a><a class="footer-link pl-2" href="/privacy">Privacy Policy</a>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>
<script>
export default {
  setup(props, context) {
    const d = new Date()
    const year = d.getFullYear()
    const version = process.env.PACKAGE_VERSION
    
    return {
      version,
      year
    }
  }
}
</script>
<style scoped lang="scss">
nav#top {
  font-family: 'Raleway', sans-serif;
  margin: 0;
  padding: 25px 0 0 0;
  // opacity: .8;
  font-size: 1rem;
  // text-transform: uppercase;
  // font-weight: 600;
  color: #fff;

  &.absolute-top {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    z-index: 1030;
  }
  .nav-link {
    font-family: inherit;
    line-height: 1.5;
    padding: .25rem .75rem;
  }
  .navbar-brand {
    padding: 1px 0;
    margin: 0px;
  }

  .navbar-brand:hover,
  .nav-item .nav-link:hover,
  .nav-item .nav-link:focus{
    background-color: transparent;
    color: #fff;
    opacity: 1;
  }

  img.logo {
    height: 72px;
    padding: 8px;
  }

}
@media (min-width: 576px) {
  nav#top .container {
    max-width: 540px;
  }
}
@media (min-width: 768px) {
  nav#top .container {
    max-width: 720px;
  }
}
@media (min-width: 992px) {
  nav#top {
    .container {
      max-width: 960px;
    }
    .navbar-expand-lg, .nav-link {
      padding-right: 1rem;
      padding-left: 1rem;
    }
  }
}
@media (min-width: 1200px) {
  nav#top .container {
    max-width: 1040px;
  }
}

// Colors
$white:    #fff !default;
$gray-100: #f6f9fc !default;
$gray-200: #e9ecef !default;
$gray-300: #dee2e6 !default;
$gray-400: #ced4da !default;
$gray-500: #adb5bd !default;
$gray-600: #8898aa !default;   // Line footer color
$gray-700: #525f7f !default;   // Line p color
$gray-800: #32325d !default;   // Line heading color
$gray-900: #212529 !default;
$black:    #000 !default;

$tertiary:      #1d345f !default;

// Fonts
$font-family-alt: 'Open Sans', sans-serif !default;

// Footer
$footer-link-font-size: .85rem !default;
$footer-bg: $tertiary !default;
$footer-color: $gray-500 !default;
$footer-link-color: $gray-500 !default;
$footer-link-hover-color: $gray-200 !default;
$footer-heading-color: $gray-500 !default;

.footer {
  background: $footer-bg;
  padding: 3rem 0;
  color: $footer-color;
  font-family: $font-family-alt;

  .nav .nav-item .nav-link,
  .footer-link {
    color: $footer-link-color !important;

    &:hover {
      color: $footer-link-hover-color !important;
    }
  }
}
</style>